import { Edit, SimpleForm } from "react-admin";
import { SaveOnlyToolbar } from "../../components/SaveOnlyToolbar";
import { TeamForm } from "./TeamForm";
import { useUpdateSubmit } from "../../forms";

const TeamEditForm = () => {
	const submit = useUpdateSubmit("teams", "Team updated");

	return (
		<SimpleForm onSubmit={submit} toolbar={<SaveOnlyToolbar />}>
			<TeamForm />
		</SimpleForm>
	);
};

export const TeamEdit = () => (
	<Edit title="Update team">
		<TeamEditForm />
	</Edit>
);
